import { headers } from "../utils/utils";
import useUsuarioStore from "./usuario";


const useChatStore = defineStore('chat',() => {

  // stados
  const chat = ref({
    id:null,
    usuario_id:null,
    cerrado:false,
    total_tokens:0,
    con_asistente:false,
    usuario:null,
    mensajes:[],
    integrantes:[],

  });

  const chatContact = ref({
    id: null,
    usuario_id: null,
    cerrado: false,
    total_tokens: 0,
    con_asistente: false,
    usuario: null,
    mensajes: [],
    integrantes: [],
  });


  const chats = ref([]);

  // getters

  const draft = computed(() => clone(chat.value));

  const contacto = computed(() => {
    const usuario_store = useUsuarioStore();
    const {usuario_id} = storeToRefs(usuario_store);
  
    if(chatContact.value && chatContact.value.integrantes.length){
        return chatContact.value.integrantes.find(i => i.usuario_id !== usuario_id.value) || null;
    }
    return null;
  
  });

   const conectado = computed(() => {
     const usuario_store = useUsuarioStore();
     
      return usuario_store.usuarioConectado(contacto.value?.usuario_id || contacto.value?.user_id)
   });

   const estado_contacto = computed(() => {
     return conectado.value ? "online" : "offline";
   });

   const leyenda_estado_contacto = computed(() => {
     return conectado.value ? "En línea" : "Desconectado";
   });



  // mutations

  const clear = () => {
    chat.value = {
      id: null,
      usuario_id: null,
      cerrado: false,
      total_tokens: 0,
      usuario: null,
      con_asistente: false,
      mensajes: [],
      integrantes: [],
    };
  };

  const clearChatContact =  () => {
    
    chatContact.value = {
      id: null,
      usuario_id: null,
      cerrado: false,
      total_tokens: 0,
      con_asistente: false,
      usuario: null,
      mensajes: [],
      integrantes: [],
    };
  }

  const limpiarChatContacto = (conversacion_id) => {
    if(chatContact.value && chatContact.value.id === conversacion_id){
      clearChatContact();
    }
  };

  const pushMensajeChatContacto= (mens) => {
    if(chatContact.value && chatContact.value.id === mens.chat_id){
      chatContact.value.mensajes.push(mens);
    }
  };


  const setChat = (new_chat) => {
    chat.value = new_chat || chat.value;
  }

  const cambiarEstatusOfertaMensaje = (msj_id, estatus ) => {

    let i = chatContact.value.mensajes.findIndex(m => m.id == msj_id);
    
    if(i  != -1){
      if(chatContact.value.mensajes[i].oferta){
        chatContact.value.mensajes[i].oferta.estatus = estatus;
      }
    }
  };

  const actualizarOfertaMensaje = (msj_id, oferta) => {

    let i = chatContact.value.mensajes.findIndex(m => m.id == msj_id);
    
    if(i  != -1){
      if(chatContact.value.mensajes[i].oferta){
        chatContact.value.mensajes[i].oferta = {
          ...chatContact.value.mensajes[i].oferta,
          ...oferta
        };
      }
    }
  };



  // actions

 

  const aperturarChat = (datos)  => {
    return new Promise((resolve, reject) => {
      axios.post(`/api/chats/aperturar`,datos)
      .then(({data}) => {
        if(data.result){
          chat.value = data.chat;
          localStorage.setItem('chat_id',data.chat.id);
          resolve(data);
        }
      }).catch(e => {
        reject(e)
      })
    })
  };


  const fetchIfActivo  = (chat_id) => {

    return new Promise((resolve, reject) => {
      axios.get(`/api/chats/${chat_id}/fetch-if-activo`)
      .then(({data}) => {
        if(data.result){
          chat.value = data.chat;
        }
        resolve(data);
      }).catch(e => reject(e));

    })
  } 

  const cerrarChat = (chat_id) => {
    return new Promise((resolve,reject) => {
        axios.get(`/api/chats/${chat_id}/cerrar`)
        .then(({data}) => {
          resolve(data);
        })
        .catch(e => {
          reject(e);
        });

    })
  };

  const iniciarChatConUsuario = async (datos) => {
    try {
      let formData = new FormData();

      for (const key in datos) {
        if(key == 'archivos'){
          formData.append('archivos[]',datos[key]);
        }else{
          formData.append(key, datos[key]);
        }
      }

      const {data} = await axios.post(`/api/chats/iniciar-chat-con-usuario`,formData,{headers});
        if(data.result) {
          chat.value = data.chat;
        }
        return data;
    } catch (error) {
        throw error;
    }
    
  };

  const verificarChatConUsuario = async (contacto_id,usuario_id) => {
    try {
        const {data} = await axios.post(`/api/chats/verificar-chat-con-usuario`,{contacto_id,usuario_id});
        return data;
    } catch (error) {
        throw error;
    }
  };

  const obtenerConversaciones = async (user_id) => {
    try {
      if(!user_id) return [];

      const { data } = await axios.get(`/api/chats/conversaciones/${user_id}`);

      if(data.length){
        chats.value = data;
      } 

      return data;

    } catch (error) {
      throw error;
    }

  };



  const eliminarConversacion = async (conversacion_id) => {
    try {
      const  {data} =  await axios.delete(`/api/chats/conversaciones/${conversacion_id}`);
      if(data.result){
        chats.value = chats.value.filter(c => c.id !== conversacion_id);
      }
      return data;
    } catch (error) {
      throw error;
    }
  };


  const fetchChatContacto = async (slug) => {
    try {
     
        const {data} = await axios.post(`/api/chats/fetch-chat-contacto`,{slug});
        if(data.result){
          chatContact.value = data.chat;
        }
        return data;
    } catch (error) {
        throw error;
    }
  };

  const rechazarOfertaMensaje = async (mensaje_id) => {
    try {
      const {data} = await axios.post(`/api/chats/rechazar-oferta-mensaje`,{mensaje_id});
      return data;
    } catch (error) {
      throw error;
    }
  };



  return {
    // states
    chat,
    chats,
    chatContact,
    // getters
    draft,
    estado_contacto,
    leyenda_estado_contacto,
    conectado,
    contacto,
    // methods or actions
    fetch,
    clear,
    aperturarChat,
    fetchIfActivo,
    cerrarChat,
    iniciarChatConUsuario,
    verificarChatConUsuario,
    obtenerConversaciones,
    eliminarConversacion,
    fetchChatContacto,
    clearChatContact,
    limpiarChatContacto,
    pushMensajeChatContacto,
    rechazarOfertaMensaje,
    cambiarEstatusOfertaMensaje,
    actualizarOfertaMensaje,
  };

});

export default useChatStore;